import {observable, action} from "mobx"
import {load} from "recaptcha-v3"

import GlobalStore from "../../global/store/GlobalStore"
import RouterStore from "../../global/store/RouterStore"
import config from "../../global/config/settings"

import {handleLogin} from "../../global/helpers/actions"

import api from "../../global/actions/api"

class LoginStore {
	@observable screen = this.screens.LOGIN

	token = null
	@observable email = ""

	screens = {
		LOGIN: "login",
		REGISTER: "register",
		FORGOT: "forgot"
	}

	@action hanldeRegistration(form) {
		GlobalStore.loading(true, "Prebieha registrácia...")

		if (GlobalStore.enabledRecaptchaV2 && isNotEmpty(GlobalStore.tokenRecaptchaV2)) {
			this.registration(form, `v2:${GlobalStore.tokenRecaptchaV2}`)
		} else {
			load(config.SITE_KEY).then((recaptcha) => {
				recaptcha.execute("client_register").then((recaptchaToken) => {
					this.registration(form, recaptchaToken)
				})
			})
		}
	}

	@action registration(form, token) {
		const values = form.values()

		const req = {
			email: values.email,
			company_name: values.company_name,
			company_identifier: values.company_identifier,
			personal_data: values.personal_data,
			communication_method: values.communication_method
		}

		if (!values.isWithoutRpo) {
			req.city_code = values.rpo_city
			req.house_number = values.rpo_house_number
			req.street = values.rpo_street
			req.zip = values.rpo_zip
			req.legal_form_name_ext = values.rpo_legal_form
		}

		api
			.registration(req, token)
			.call()
			.then((res) => {
				if (isSafe(res)) {
					form.reset()
					GlobalStore.openConfirmRegistrationDialog()
					RouterStore.push("/login")
				}
				GlobalStore.loading(false)
			})
	}

	@action handleRegistrationFinish(form) {
		GlobalStore.loading(true)

		if (GlobalStore.enabledRecaptchaV2 && isNotEmpty(GlobalStore.tokenRecaptchaV2)) {
			this.registrationFinish(form, `v2:${GlobalStore.tokenRecaptchaV2}`)
		} else {
			load(config.SITE_KEY).then((recaptcha) => {
				recaptcha.execute("client_action_consume").then((recaptchaToken) => {
					this.registrationFinish(form, recaptchaToken)
				})
			})
		}
	}

	@action registrationFinish(form, token) {
		const {password} = form.values()

		const req = {
			password: password,
			as_login: true
		}

		api
			.registrationFinish(req, this.token, token)
			.call()
			.then((res) => {
				if (isSafe(res) && isNotEmpty(res.login)) {
					handleLogin(res.login, password)
				}
			})
	}

	@action handleResetPassword(form) {
		GlobalStore.loading(true, "Reset password...")

		if (GlobalStore.enabledRecaptchaV2 && isNotEmpty(GlobalStore.tokenRecaptchaV2)) {
			this.resetPassword(form, `v2:${GlobalStore.tokenRecaptchaV2}`)
		} else {
			load(config.SITE_KEY).then((recaptcha) => {
				recaptcha.execute("client_reset_password").then((recaptchaToken) => {
					this.resetPassword(form, recaptchaToken)
				})
			})
		}
	}

	@action resetPassword(form, token) {
		const req = form.values()

		api
			.resetPassword(req, token)
			.call()
			.then(() => {
				form.reset()
				this.screen = this.screens.LOGIN
				GlobalStore.setNotificationMessage("Žiadosť na zmenu hesla odoslaná", "", "success")
				GlobalStore.loading(false)
			})
	}

	@action handleResetPasswordFinish(form) {
		GlobalStore.loading(true)

		if (GlobalStore.enabledRecaptchaV2 && isNotEmpty(GlobalStore.tokenRecaptchaV2)) {
			this.resetPasswordFinish(form, `v2:${GlobalStore.tokenRecaptchaV2}`)
		} else {
			load(config.SITE_KEY).then((recaptcha) => {
				recaptcha.execute("client_action_consume").then((recaptchaToken) => {
					this.resetPasswordFinish(form, recaptchaToken)
				})
			})
		}
	}

	@action resetPasswordFinish(form, token) {
		const {password} = form.values()

		const req = {
			password: password,
			as_login: true
		}

		api
			.registrationFinish(req, this.token, token)
			.call()
			.then((res) => {
				if (isSafe(res)) {
					GlobalStore.setNotificationMessage("Heslo bolo úspešne zmenené", "", "success")
					GlobalStore.loading(false)
					RouterStore.push("/login")
				}
			})
	}
}

var singleton = new LoginStore()
export default singleton

